/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MethodInputs */

const en_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Method`)
};

const es_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método`)
};

const de_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Methode`)
};

const zh_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方法`)
};

const ar_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنهج`)
};

const fr_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode`)
};

const vi_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp`)
};

const sw_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu`)
};

const th_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธีการ`)
};

const bs_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const ja_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メソッド`)
};

const ko_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메서드`)
};

const pt_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Método`)
};

const it_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il Metodo`)
};

const sv_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoden`)
};

const nl_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De methode`)
};

const da_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoden`)
};

const nb_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoden`)
};

const fi_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodi`)
};

const pl_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const ru_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод`)
};

const tr_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yöntem`)
};

const hi_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विधि`)
};

const id_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metode`)
};

const ms_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaedah`)
};

const cs_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda`)
};

const el_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος`)
};

const he_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השיטה`)
};

const af_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die metode`)
};

const hu_nav_method = /** @type {(inputs: Nav_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A módszer`)
};

/**
* | output |
* | --- |
* | "The Method" |
*
* @param {Nav_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_method = /** @type {((inputs?: Nav_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_method(inputs)
	if (locale === "de") return de_nav_method(inputs)
	if (locale === "zh") return zh_nav_method(inputs)
	if (locale === "ar") return ar_nav_method(inputs)
	if (locale === "fr") return fr_nav_method(inputs)
	if (locale === "vi") return vi_nav_method(inputs)
	if (locale === "sw") return sw_nav_method(inputs)
	if (locale === "th") return th_nav_method(inputs)
	if (locale === "bs") return bs_nav_method(inputs)
	if (locale === "ja") return ja_nav_method(inputs)
	if (locale === "ko") return ko_nav_method(inputs)
	if (locale === "pt") return pt_nav_method(inputs)
	if (locale === "it") return it_nav_method(inputs)
	if (locale === "sv") return sv_nav_method(inputs)
	if (locale === "nl") return nl_nav_method(inputs)
	if (locale === "da") return da_nav_method(inputs)
	if (locale === "nb") return nb_nav_method(inputs)
	if (locale === "fi") return fi_nav_method(inputs)
	if (locale === "pl") return pl_nav_method(inputs)
	if (locale === "ru") return ru_nav_method(inputs)
	if (locale === "tr") return tr_nav_method(inputs)
	if (locale === "hi") return hi_nav_method(inputs)
	if (locale === "id") return id_nav_method(inputs)
	if (locale === "ms") return ms_nav_method(inputs)
	if (locale === "cs") return cs_nav_method(inputs)
	if (locale === "el") return el_nav_method(inputs)
	if (locale === "he") return he_nav_method(inputs)
	if (locale === "af") return af_nav_method(inputs)
	if (locale === "hu") return hu_nav_method(inputs)
	return en_nav_method(inputs)
});